module.exports = __webpack_public_path__ + "static/media/indorse-logo@2x.9e4d6eb4.png";